<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Maintenance'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        @if (maintenance?.maintenance?.photo_url) {
          <tidy-row>
            <div style="margin-top:-15px; margin-left:-15px; margin-right:-15px">
              <img [src]="maintenance?.maintenance?.photo_url">
            </div>
          </tidy-row>
        }
        <tidy-row class="vertical-align-center">
          <tidy-text
            [actionBody]="maintenance?.room_object?.model?.category?.name"
            (action)="goToItemDetails()"
            class="link" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [title]="maintenance?.maintenance?.name" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/calendar-outline.svg'"
            class="body-size" />
          <tidy-text
            [body]="'Do next:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="maintenance?.next_due_date  | parseDateTime: 'MMM d'" />
          </tidy-row>
          @if (maintenance?.last_maintenance_at) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/checkmark-circle-outline.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Last completed:'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="maintenance?.last_maintenance_at  | parseDateTime: 'MMM d'" />
              </tidy-row>
            }
            @if (!maintenance?.last_maintenance_at) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/close-circle-outline.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="'Never completed before'" />
              </tidy-row>
            }
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/refresh-circle-outline.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Frequency:'" /><span>&nbsp;</span>
                <tidy-text
            [body]="maintenance?.maintenance?.frequency + ' ' + maintenance?.maintenance?.frequency_unit + (maintenance?.maintenance?.frequency > 1 ? ('(s)' | translate) : '')" />
        </tidy-row>
      </tidy-card>

      @for (step of maintenance?.maintenance?.steps; track step; let index = $index) {
<tidy-card>
        <tidy-row style="background:#4BA7B7; margin-top:-15px; margin-left:-15px; margin-right:-15px; padding-top: 5px; padding-bottom:10px">
          <span class="item-menu" style="margin-left:15px; color: white;
          font-family: Neuton, serif;
          font-size: 13px;
          font-weight: bold;">
                    STEP {{index+1}}
                  </span><br>
                  <tidy-text
                    style="margin-left:15px; color:white"
                    [header]="step?.title" />
                </tidy-row>
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [body]="step?.description" />
                </tidy-row>
                @if (step?.medias?.length) {
                  <div style="margin-bottom:-30px; margin-left:-15px; margin-right:-15px">
                    <tidy-carrousel [scaleImages]="true">
                      @for (photo of step?.medias; track photo) {
                        <tidy-photo-note
                          [src]="photo?.url"
                          class="full-width there-is-carrousel no-margin"
                          *tidyCarrousel />
                      }
                    </tidy-carrousel>
                  </div>
                }
              </tidy-card>
            }
            <tidy-button
              [text]="'Mark Complete'"
              class="primary"
              [action]="submitStatus.bind(this, 'completed')" />
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Skip Maintenance'"
                (action)="submitStatus('skipped')"
                class="link" />
            </tidy-row>
          }

          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }

        </tidy-wrapper>
      </ng-template>

      <app-scroll-wrapper [templateContent]="content" />
